module.exports = __webpack_public_path__ + "static/media/rastreamento.e0ba32e4.png";